export default "__VITE_ASSET__Dgi31d5M__ 100w";